import { createBrowserHistory } from "history";

import * as Sentry from "@sentry/react";

// Create Custom Sentry Route component
const history = createBrowserHistory();

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  enabled: process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'staging',
  ignoreErrors: [
    "FirebaseError"
  ],
  integrations: [
    Sentry.reactRouterV5BrowserTracingIntegration({ history }),
    // OR
    Sentry.reactRouterV4BrowserTracingIntegration({ history }),
  ],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});
